import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueSnackbar from 'vue-snack'
import dataHandler from './DataHandler'
import axios from 'axios'
import 'vue-snack/dist/vue-snack.min.css'

// Restaurer les credentials axios depuis la session au rechargement de page
const credentials = sessionStorage.getItem('up_credentials');
if (credentials) {
  axios.defaults.headers.common['Authorization'] = 'Basic ' + credentials;
  dataHandler.initSocketHandler(store);
}

Vue.config.productionTip = false
Vue.use(VueSnackbar)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');